/**
 * Slide-over open-state store.
 *
 * The slide-over surface mounts at the application shell level (per
 * Claude Design Files README section 5.12 — task variant — and 5.13 —
 * deal variant), but it opens from a dozen different places (a board
 * card click, a queue row click, an inline-edit "expand" affordance,
 * the command bar, and so on). A Zustand slice keeps the open state
 * available everywhere without prop-drilling.
 *
 * M2 ships only the mount point and the open/close machinery so M4+
 * surfaces can call `useSlideOver().open(...)` without wiring up new
 * plumbing. The slide-over content itself ships in M8 per
 * spec section 15.8.
 */

import { create } from 'zustand';

export type SlideOverTarget =
  | { kind: 'task'; taskId: string }
  | { kind: 'lead'; leadId: string }
  | { kind: 'opportunity'; opportunityId: string };

interface SlideOverState {
  target: SlideOverTarget | null;
  open: (target: SlideOverTarget) => void;
  close: () => void;
}

export const useSlideOver = create<SlideOverState>((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));
